import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BettingPrematchComponent } from './components/betting-prematch/betting-prematch.component';
// import { BettingLiveComponent } from './components/betting-live/betting-live.component';
import { ResultsComponent } from './components/results/results.component';
import { TestComponent } from './components/test/test.component';

const routes: Routes = [
  {
    path: 'betting/prematch',
    component: BettingPrematchComponent,
  },
  // {
  //   path: 'betting/live',
  //   component: BettingLiveComponent,
  // },
  {
    path: 'results',
    component: ResultsComponent,
  },
  {
    path: 'account',
    loadChildren: () => import(`./ticket-manager/ticket-manager.module`).then(
      module => module.TicketManagerModule
    )
  },
  // {
  //   path: 'ticketManager/login',
  //   component: LoginComponent,
  // },
  {
    path: 'betting/live',
    loadChildren: () => import(`./live.module`).then(
      module => module.LiveModule
    ),
  },
  // {
  //   path: 'results/:resultsType',
  //   component: ResultsComponent
  // },
  // {
  //   path: 'home',
  //   component: SettingsComponent
  // },
  // {
  //   path: 'help',
  //   component: HelpComponent
  // },
  {
    path: '',
    redirectTo: '/betting/prematch',
    pathMatch: 'full',
  },
  // {
  //   path: 'test',
  //   component: TestComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
